import { useEffect } from "react";

import { toast } from "extensions/toast";

export const NavigatorOnline = function(props) {
    let activeToast;
    
    const getStatus = () => {
        if (activeToast) {
            toast.dismiss(activeToast);
        }
        
        if (navigator.onLine) {
            activeToast = toast.success("Your device is connected to the internet.");
        } else {
            activeToast = toast.error("Your device lost its internet connection.");
        }
    };
    
    useEffect(() => {
        window.addEventListener("online", getStatus);
        window.addEventListener("offline", getStatus);
    
        // Specify how to clean up after this effect:
        return () => {
            window.removeEventListener("online", getStatus);
            window.removeEventListener("offline", getStatus);
        };
    });
    
    // Return null to not render a component
    return null;
};
